import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

export const logo = 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Youtube_logo.png';

// Pendiente: hacer cambio de idiomas con FormatJS
export const categories = [
  { name: 'Inicio', icon: <HomeIcon />, },
  { name: 'Música', icon: <MusicNoteIcon /> },
  { name: 'Películas', icon: <OndemandVideoIcon />, },
  { name: 'En vivo', icon: <LiveTvIcon />, },
  { name: 'Videojuegos', icon: <SportsEsportsIcon />, },
  { name: 'Deportes', icon: <FitnessCenterIcon />, },
  { name: 'Aprendizaje', icon: <SchoolIcon />, },
  { name: 'Podcast', icon: <GraphicEqIcon />, },
  { name: 'Programación', icon: <CodeIcon />, },
  { name: 'Belleza', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Comedia', icon: <TheaterComedyIcon />, },
  { name: 'Ejercicio', icon: <FitnessCenterIcon />, },
];

export const demoThumbnailUrl = 'https://i.ytimg.com/vi/4mgJPXD_7Xk/maxresdefault.jpg';
export const demoChannelUrl = '/channel/UC8butISFwT-Wl7EV0hUK0BQ';
export const demoVideoUrl = '/video/XqFR2lqBYPs';
export const demoChannelTitle = 'freeCodeCamp Español';
export const demoVideoTitle = 'Aprende HTML y CSS - Curso Desde Cero';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'